import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, ChevronRight } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  return <section id="compra" className="py-12 px-4 bg-brand-black relative" data-id="element-75">
      <div className="max-w-4xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card rounded-3xl p-6 md:p-10 text-center text-white shadow-2xl relative overflow-hidden border border-brand-green/20" data-id="element-77">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-green/15 rounded-full blur-[80px]" data-id="element-78"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-green/15 rounded-full blur-[80px]" data-id="element-79"></div>

          <div className="relative z-10" data-id="element-80">
            <h2 className="font-display text-2xl md:text-4xl uppercase mb-3" data-id="element-81">
              Empezá a ganar <span className="text-brand-green" data-id="element-82">hoy mismo</span>
            </h2>
            <p className="font-body text-sm md:text-base text-gray-300 mb-5 max-w-2xl mx-auto" data-id="element-83">
              Llevate los 6 Tomos de Padel Zurdo Pro + los 3 Bonos Exclusivos
              con acceso inmediato.
            </p>

            <CountdownTimer data-id="element-84" />

            <div className="bg-brand-black rounded-2xl px-6 py-6 max-w-sm mx-auto border border-brand-green/30 mb-6" data-id="element-85">
              <p className="font-body text-gray-500 line-through text-base mb-2" data-id="element-86">
                Precio normal: $49.990
              </p>
              <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-87">
                <span className="font-display text-xl text-brand-green" data-id="element-88">$</span>
                <span className="font-display text-5xl text-white leading-none" data-id="element-89">
                  19.990
                </span>
                <span className="font-display text-base text-brand-green ml-1" data-id="element-90">
                  ARS
                </span>
              </div>
              <p className="font-body text-brand-green font-medium text-xs" data-id="element-91">
                Pago único · Acceso de por vida.
              </p>
            </div>

            <a href="https://checkout.ebookpoint.shop/cart/59466975805521:1" className="inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-darkGreen text-brand-black font-display text-lg md:text-xl py-4 px-8 rounded-xl transition-all transform hover:scale-105 hover:shadow-xl hover:shadow-brand-green/30 w-full md:w-auto mb-5" data-id="element-92">
              QUIERO USAR MI ZURDA COMO VENTAJA
              <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-93" />
            </a>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-xs font-body text-gray-400" data-id="element-94">
              <div className="flex items-center gap-2" data-id="element-95">
                <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-96" />
                <span data-id="element-97">Garantía de satisfacción</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-98">
                <Lock className="w-4 h-4 text-brand-green" data-id="element-99" />
                <span data-id="element-100">Pago 100% seguro</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}